import { Link } from 'react-router-dom';
import { GUIDES } from '../content/guides';

// Compact here too. `.footer img` is 24px tall and the stacked lockup's byline
// would land near 5px — the full lockup needs roughly 56px before "by
// intake.dental" is readable, so it is reserved for the og card and anywhere
// it gets displayed large. The footer already links to intake.dental below.
const LOGO = '/send-lockup-compact.svg';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-brand">
        <img src={LOGO} alt="SEND by Intake.Dental" />
        <span>Secure file transfer · HIPAA-compliant · free for dental offices</span>
      </div>
      {/* The task pages need internal links, not just a sitemap entry — a page
          reachable only from sitemap.xml is a page Google treats as an orphan. */}
      <div className="footer-links">
        {GUIDES.map((g) => (
          <Link key={g.slug} to={`/${g.slug}`}>{g.h1.replace(/^How to /, '')}</Link>
        ))}
      </div>
      <div className="footer-links">
        <Link to="/how-it-works">How it works</Link>
        <Link to="/security">Security</Link>
        <Link to="/faq">FAQ</Link>
        <a href="https://intake.dental" target="_blank" rel="noreferrer">intake.dental</a>
        <a href="mailto:support@intake.dental">support@intake.dental</a>
      </div>
    </footer>
  );
}
